import React, { FunctionComponent, ReactElement, ReactNode } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { PageNotFound } from './features/ErrorPages/PageNotFound';
import { PartsPage } from './features/Parts/containers/PartsPage/PartsPage';
import { InvoicePage } from './features/Invoice/InvoicePage';

const PartsSearch = React.lazy(() =>
	import('./features/Parts/containers/PartsPage/PartsPage').then(module => ({ default: module.PartsPage })),
);
const ShoppingCart = React.lazy(() =>
	import('./features/ShoppingCart/containers/ShoppingCartPage').then(module => ({ default: module.ShoppingCartPage })),
);
const Orders = React.lazy(() =>
	import('./features/Orders/containers/OrdersPage/OrdersPage').then(module => ({ default: module.OrdersPage })),
);
const OrderDetails = React.lazy(() =>
	import('./features/Orders/containers/OrderDetailsPage/OrderDetailsPage').then(module => ({
		default: module.OrderDetailsPage,
	})),
);
const Profile = React.lazy(() =>
	import('./features/Profile/containers/ProfilePage/ProfilePage').then(module => ({ default: module.ProfilePage })),
);
const Checkout = React.lazy(() =>
	import('./features/Checkout/containers/CheckoutPage/CheckoutPage').then(module => ({ default: module.CheckoutPage })),
);

/* eslint-disable react/no-multi-comp */
const SuspenseWrapper: FunctionComponent<{ component: ReactNode }> = ({ component }) => (
	<React.Suspense fallback={<>...</>}>{component}</React.Suspense>
);

export const AppRouting: FunctionComponent = (): ReactElement => {
	const routes = useRoutes([
		{
			path: '/',
			element: <InvoicePage />,
		},
		/*{
      		path: '/parts',
      		element: <Navigate to="/" replace={true} />,
    	},*/
		{
			path: '/parts',
			element: <SuspenseWrapper component={<PartsSearch />} />,
		},
		
		{
			path: '/shopping-cart',
			element: <SuspenseWrapper component={<ShoppingCart />} />,
		},
		{
			path: '/checkout',
			element: <SuspenseWrapper component={<Checkout />} />,
		},
		{
			path: '/profile',
			element: <SuspenseWrapper component={<Profile />} />,
		},
		{
			path: '/orders',
			children: [
				{
					index: true,
					element: <SuspenseWrapper component={<Orders />} />,
				},
				{
					path: ':id',
					element: <SuspenseWrapper component={<OrderDetails />} />,
				},
			],
		},
		{
			path: '*',
			element: <PageNotFound />,
		},
	]);

	return <main className="main-section">{routes}</main>;
};
